// refer to: https://euvl.github.io/vue-js-modal/Properties.html#properties-2

import { cssUnitsToPixels } from "Helpers/dom-manip";

export default {
  props: {
    // required
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: 'Notice:',
    },
    // optional
    styles: {
      type: [String, Array, Object],
      required: false,
      default: null,
    },
    width: {
      type: String,
      required: false,
      default: '700',
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
    icon: {
      type: String,
      required: false,
      default: 'la la-exclamation-circle',
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    draggable: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    adaptive: {
      type: Boolean,
      required: false,
      default: false,
    },
    resizable: {
      type: Boolean,
      required: false,
      default: false,
    },
    minWidth: {
      type: Number,
      required: false,
      default: 150,
    },
    minHeight: {
      type: Number,
      required: false,
      default: 150,
    },
    maxWidth: {
      type: Number,
      required: false,
      default: Infinity,
    },
    maxHeight: {
      type: Number,
      required: false,
      default: Infinity,
    },
    shiftX: {
      type: Number,
      required: false,
      default: 0.5,
    },
    shiftY: {
      type: Number,
      required: false,
      default: 0.5,
    },
    focusTrap: {
      type: Boolean,
      required: false,
      default: true,
    },
    overlayTransition: {
      type: Boolean,
      required: false,
      default: null,
    },
    titleJustify: {
      type: String,
      required: false,
      default: 'space-between',
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    clickToClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    scrollable: { // note: this contols whether or not the modal can scroll if it matches the screen height - avoid using unless needed (see innerScrollable)
      type: Boolean,
      required: false,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    bodyScroll: {
      type: Boolean,
      required: false,
      default: false,
    },
    callback: {
      type: Function,
      required: false,
      default: null,
    },
    callback_timeout: {
      type: Number,
      required: false,
      default: 5000,
    },
  },
  computed: {
    background_closeable() {
      return this.clickToClose && !this.waiting_callback;
    },
    width_in_pixels() {
      // if string contains digits followed by alpha (i.e a value with a unit), convert to px, otherwise pass along
      return this.width.match(/\d+[a-zA-Z]+/g) ? cssUnitsToPixels(this.width) : this.width;
    },
    height_in_pixels() {
      // if string contains digits followed by alpha (i.e a value with a unit), convert to px, otherwise pass along
      return this.height.match(/\d+[a-zA-Z]+/g) ? cssUnitsToPixels(this.height) : this.height;
    },
  },
  data: () => ({
    event_name: 'modal-complete',
    close_data: {},
    waiting_callback: false,
  }),
  methods: {
    async complete(extra_data, skip_callback) {
      const data = {
        ...(this.close_data ?? {}),
        ...(extra_data ?? {}),
      };
      const cb_result = await (() => {
        try {
          if (this.callback != null && typeof this.callback === 'function' && !skip_callback && data.confirm) {
            this.waiting_callback = true;
            return Promise.race([
              this.callback(data),
              new Promise(res => setTimeout(res, this.callback_timeout)),
            ]);
          }
        } catch (err) {
          window.handleAxiosError(err);
        }
      })();
      this.waiting_callback = false;

      EventBus.$emit(this.event_name, {
        name: this.name,
        type: this.$options.name,
        data: (Object.keys(data).length || cb_result) ? {
          ...data,
          callback_result: cb_result,
        } : null,
      });
      if (this.autoClose) {
        this.$modal.hide(this.name);
      }
    },
  },
};
